import React from 'react';
import { PieChart, Pie, Cell, Legend, Tooltip, ResponsiveContainer } from 'recharts';

interface PlanBreakdownProps {
  data: Array<{ name: string; value: number }>;
}

const COLORS = ['#b4a3ff', '#08d660', '#ffa500', '#e84c3d', '#6b7280', '#9ca3af'];

export function PlanBreakdown({ data }: PlanBreakdownProps) {
  const displayData = data && data.length > 0 ? data : getDemoPlanData();
  const totalValue = displayData.reduce((sum, item) => sum + item.value, 0);

  return (
    <div
      className="rounded-2xl p-6 backdrop-blur-sm border"
      style={{
        backgroundColor: '#111116',
        borderColor: '#1e1e25',
      }}
    >
      <div className="mb-6">
        <h3 style={{ color: '#f5f5f7' }} className="text-lg font-semibold">
          Breakdown por Plano
        </h3>
        <p style={{ color: '#8a8a95' }} className="text-sm">
          Distribuição de receita
        </p>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={displayData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, value }) => `${name}: R$ ${value.toFixed(0)}`}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
          >
            {displayData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip
            contentStyle={{
              backgroundColor: '#131318',
              border: '1px solid #1e1e25',
              borderRadius: '8px',
              color: '#f5f5f7',
            }}
            formatter={(value: number) => `R$ ${value.toFixed(2)}`}
          />
          <Legend wrapperStyle={{ color: '#75757f' }} />
        </PieChart>
      </ResponsiveContainer>

      <div
        className="mt-6 space-y-2 border-t pt-4"
        style={{ borderColor: '#1e1e25' }}
      >
        <div className="flex justify-between text-sm">
          <span style={{ color: '#8a8a95' }}>Total de Receita</span>
          <span style={{ color: '#f5f5f7' }} className="font-bold">
            R$ {totalValue.toFixed(2)}
          </span>
        </div>
        <div className="flex justify-between text-sm">
          <span style={{ color: '#8a8a95' }}>Planos Ativos</span>
          <span style={{ color: '#f5f5f7' }} className="font-bold">
            {displayData.length}
          </span>
        </div>
      </div>
    </div>
  );
}

function getDemoPlanData() {
  return [
    { name: 'Básico Mensal', value: 5200 },
    { name: 'Trimestral', value: 8100 },
    { name: 'Profissional', value: 12500 },
    { name: 'Enterprise', value: 18900 },
  ];
}
